<template>
  <button 
    :class="['btn-custom', Cls,colorType, size ,{ 'is-outline': outline }]" 
    :style="'width:'+Width+'%'"
    v-on="$listeners"
  >
    <span class="btn-content">
      <slot></slot>
    </span>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    // رنگ‌ها: 'primary', 'success', 'danger', 'warning', 'info', 'dark'
    colorType: {
      type: String,
      default: 'primary'
    },
    // سایزها: 'xs', 'sm', 'md', 'lg', 'xl'
    size: {
      type: String,
      default: 'md'
    },
    outline: {
      type: Boolean,
      default: false
    },
    // width: 'w-100' , w-75 , w-50 , w-25
    Width: {
      type: String,
      default: ''
    },
    Cls: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* تعریف متغیرهای رنگی مدرن */
.btn-custom {
  --primary: #6366f1;   /* بنفش نئونی */
  --success: #459914;   /* سبز زمردی */
  --danger: #ef4444;    /* قرمز رز */
  --warning: #f59e0b;   /* زرد کهربایی */
  --info: #3b82f6;      /* آبی آسمانی */
  --dark: #1f2937;      /* زغالی */
  
  --transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  
  position: relative;
  padding: 12px 28px;
  border-radius: 10px;
  font-family: inherit;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  outline: none;
  border: 2px solid transparent;
  display: inline-block;
  overflow: hidden;
  transition: var(--transition);
  z-index: 1;
  background-color: transparent;
}

/* --- مدیریت سایزها --- */
.xs { padding: 4px 12px; font-size: 11px; border-radius: 4px; }
.sm { padding: 8px 20px; font-size: 13px; border-radius: 6px; }
.md { padding: 12px 30px; font-size: 14px; border-radius: 8px; }
.lg { padding: 16px 40px; font-size: 18px; border-radius: 10px; }
.xl { padding: 20px 52px; font-size: 22px; border-radius: 12px; }

/* استایل‌های رنگی داینامیک */
.primary { --current-color: var(--primary); }
.success { --current-color: var(--success); }
.danger  { --current-color: var(--danger); }
.warning { --current-color: var(--warning); }
.info    { --current-color: var(--info); }
.dark    { --current-color: var(--dark); }


/* --- حالت ساده (Solid) --- */
.btn-custom:not(.is-outline) {
  background-color: var(--current-color);
  color: white;
  box-shadow: 0 4px 12px -4px var(--current-color);
}

.btn-custom:not(.is-outline):hover {
  /* transform: translateY(-3px); */
  box-shadow: 0 12px 20px -8px var(--current-color);
  filter: brightness(1.1);
}

/* انیمیشن لایه داخلی برای حالت Solid */
.btn-custom:not(.is-outline)::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: 0.6s;
}

.btn-custom:not(.is-outline):hover::after {
  left: 100%;
}

/* --- حالت دور خط‌دار (Outline) --- */
.is-outline {
  border-color: var(--current-color);
  color: var(--current-color);
}

.is-outline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: var(--current-color);
  transition: var(--transition);
  z-index: -1;
}

.is-outline:hover {
  color: white;
}

.is-outline:hover::before {
  width: 100%;
}

/* انیمیشن کلیک */
.btn-custom:active {
  transform: scale(0.95);
}
</style>